import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => { api.get("/portfolio").then((r) => setItems(r.data)); }, []);

  const styles = ["All", ...Array.from(new Set(items.map((i) => i.style)))];
  const filtered = filter === "All" ? items : items.filter((i) => i.style === filter);

  return (
    <div data-testid="portfolio-page" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
      <div className="max-w-4xl">
        <p className="overline">Portfolio</p>
        <h1 className="font-heading text-5xl sm:text-7xl font-light tracking-[-0.02em] mt-5 leading-[1.02]">
          Spaces we've <em className="italic">quietly transformed.</em>
        </h1>
        <p className="mt-7 text-lg text-[#5C5752] leading-[1.85] font-light max-w-2xl">
          A selection from our recent commissions across Bengaluru — every project starts with a conversation, ends with keys, and stays with a 5-year workmanship warranty backed by manufacturer warranties on hardware and materials.
        </p>
      </div>

      {items.length > 0 && (
        <div className="mt-14 flex flex-wrap gap-2.5">
          {styles.map((s) => (
            <button
              key={s}
              data-testid={`portfolio-filter-${s.toLowerCase()}`}
              onClick={() => setFilter(s)}
              className={`px-5 py-2.5 text-[11px] uppercase tracking-[0.25em] rounded-full border transition-all ${
                filter === s
                  ? "bg-[#1C1A17] text-white border-[#1C1A17]"
                  : "bg-white text-[#1C1A17] border-[#E8E2D5] hover:border-[#1C1A17]"
              }`}
            >{s}</button>
          ))}
        </div>
      )}

      {items.length === 0 ? (
        <div data-testid="portfolio-empty-state" className="mt-24 border-t border-b border-[#E8E2D5] py-24 text-center">
          <p className="overline text-[#A07F2D]">Coming soon</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-light mt-4 max-w-xl mx-auto leading-tight">
            Our latest projects are being curated. Check back soon.
          </h2>
          <p className="mt-5 text-sm text-[#5C5752] max-w-md mx-auto">
            In the meantime, we'd love to hear about your home.
          </p>
          <Link to="/book" data-testid="portfolio-empty-cta" className="btn-primary mt-8 inline-flex">Book a Consultation</Link>
        </div>
      ) : (
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {filtered.map((p, i) => (
            <article key={p.id} data-testid={`portfolio-item-${i}`} className={`group ${i % 3 === 1 ? "lg:translate-y-16" : ""}`}>
              <div className="img-zoom rounded-img-lg">
                <img src={p.cover_image} alt={p.title} className="w-full aspect-[4/5] object-cover" />
              </div>
              <div className="mt-6 px-1">
                <div className="flex items-center justify-between">
                  <p className="font-heading text-2xl">{p.title}</p>
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#A07F2D]">{p.style}</span>
                </div>
                <p className="text-sm text-[#5C5752] mt-1.5">{p.location} · {p.bhk}</p>
                <p className="text-sm mt-3 text-[#1C1A17]/75 leading-relaxed font-light">{p.description}</p>
              </div>
            </article>
          ))}
        </div>
      )}

      <div className="mt-32 text-center max-w-2xl mx-auto">
        <p className="overline">Begin yours</p>
        <h2 className="font-heading text-4xl sm:text-5xl font-light mt-4 leading-tight">Your home could be the next entry here.</h2>
        <Link to="/book" className="btn-primary mt-10">Book a Consultation</Link>
      </div>
    </div>
  );
}
